import React from "react";
import { useTranslation } from "react-i18next";
import AppDialog from "../../Components/Dialogs/AppDialog/AppDialog";
import { IMediaAssetModel, MEDIA_TYPE, isVideoAttachment, mediaThumbnailUrl } from "../../Services/MediaAssetService";
import "./SelectExistingMediaDialog.scss";

interface SelectExistingMediaDialogProps {
    visible: boolean;
    onHide: () => void;
    /** Already filtered by the parent to valid, not-yet-in-this-section candidates. Each one carries its own
     *  thumbnail URL (it comes with the article's media list), so opening the dialog costs no request. */
    candidates: IMediaAssetModel[];
    onSelect: (asset: IMediaAssetModel) => void;
}

/** Lets an author reuse an already-uploaded photo/video (from anywhere else on the article) instead of
 *  uploading the same file twice — e.g. picking existing attachments for a slideshow. */
const SelectExistingMediaDialog: React.FC<SelectExistingMediaDialogProps> = ({ visible, onHide, candidates, onSelect }) => {
    const { t } = useTranslation();

    return (
        <AppDialog
            visible={visible}
            onHide={onHide}
            header={t("knowledgeBase.form.selectExistingMedia") as string}
            style={{ width: "min(90vw, 640px)" }}
        >
            {candidates.length === 0 ? (
                <p className="select-existing-media-dialog__empty">{t("knowledgeBase.form.noExistingMedia")}</p>
            ) : (
                <div className="select-existing-media-dialog__grid">
                    {candidates.map((asset) => (
                        <button
                            key={asset.uuid}
                            type="button"
                            className="select-existing-media-dialog__item"
                            onClick={() => onSelect(asset)}
                        >
                            {mediaThumbnailUrl(asset) ? (
                                <img src={mediaThumbnailUrl(asset)} alt="" />
                            ) : (
                                <i className={`pi ${asset.mediaType === MEDIA_TYPE.VIDEO || isVideoAttachment(asset) ? "pi-video" : "pi-image"}`} />
                            )}
                            <span>{asset.originalFilename}</span>
                        </button>
                    ))}
                </div>
            )}
        </AppDialog>
    );
};

export default SelectExistingMediaDialog;
